import { getDate } from "medere-ui-framework";
import { DisposablesBudgetDetailDTO, EquipmentBudgetDetailDTO, ExtrasBudgetDetailDTO, HospitalizationDaysBudgetDetailDTO, MedicinesBudgetDetailDTO, NutritionalSupportBudgetDetailDTO, ProfessionalActivityBudgetDetailDTO } from "./BudgetDetailDTO";

export interface BudgetDTO{
    budget: number | null;
    budgetnumber?: number | null;

    date: Date | null;

    addressee: string | null;
    dni: string | null;
    affiliatenumber: string | null;

    duration: number | null;
    budgetvalidity:number | null;
    paymentvalidity:number | null;

    detail: string | null;
    observations: string | null;

    agreement : number | null;
    agreementdesc: string | null;

    agreementplan : number | null;
    agreementplandesc: string | null;

    budgetstate : number | null;
    budgetstatedescription: string | null;
    laststatechange: Date | null;

    professionalActivities: ProfessionalActivityBudgetDetailDTO[];
    disposables: DisposablesBudgetDetailDTO[];
    equipments: EquipmentBudgetDetailDTO[];
    hospitalizationDays: HospitalizationDaysBudgetDetailDTO[];
    nutritionalSupportItems: NutritionalSupportBudgetDetailDTO[];
    medicines: MedicinesBudgetDetailDTO[];
    extras: ExtrasBudgetDetailDTO[];

    total: number | null;

    patient: number;
    patientdesc:string;

    attentionmodality: number;
    attentionmodalitydesc:string;

    billingentity: number;
    billingentitydesc:string;

    hospitalization?: number;
    surgery?: number;

}

export function adaptBudgetDTO(budget: BudgetDTO): BudgetDTO {
    return {
      ...budget,
      date: getDate(budget.date),
      laststatechange: getDate(budget.laststatechange),
      professionalActivities: budget.professionalActivities ?? [],
      disposables: budget.disposables ?? [],
      equipments: budget.equipments ?? [],
      hospitalizationDays: budget.hospitalizationDays ?? [],
      nutritionalSupportItems: budget.nutritionalSupportItems ?? [],
      medicines: budget.medicines ?? [],
      extras: budget.extras ?? [],
    };
}

export const defaultBudgetDTO: BudgetDTO = {
    budget: null, 

    date: new Date(),

    addressee: '', 
    dni: '',
    affiliatenumber: '',

    duration: null, 
    detail: '',
    observations: '',

    agreement: -1, 
    agreementdesc: '', 

    agreementplan: -1, 
    agreementplandesc: '', 

    budgetstate : -1,
    budgetstatedescription: '',
    laststatechange: null,

    budgetvalidity:10,
    paymentvalidity:15,

    professionalActivities: [],
    disposables: [],
    equipments: [],
    hospitalizationDays: [],
    nutritionalSupportItems: [],
    medicines: [],
    extras: [],

    total: 0,

    patient: -1,
    patientdesc:'',
    attentionmodality: -1,
    attentionmodalitydesc:'',
    billingentity: -1,
    billingentitydesc:''
};
